import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { AnimatedSection } from './AnimatedSection';
const faqs = [{
  q: 'Funziona con tutti i corrieri?',
  a: 'Sì. Integriamo i principali corrieri italiani e internazionali (BRT, GLS, SDA, Poste, DHL, ecc.) tramite API. Possiamo aggiungere corrieri custom su richiesta.'
}, {
  q: 'Quanto costa?',
  a: 'Il pricing dipende dai moduli attivati e dai volumi di spedizione. È un modello pay-per-use scalabile: paghi solo per le operazioni realmente processate, senza costi fissi di licenza.'
}, {
  q: "Quanto tempo serve per l'integrazione?",
  a: "Pochi giorni per i moduli standard. Il nostro team gestisce l'integrazione diretta con il tuo CRM, ERP o piattaforma e-commerce, riducendo al minimo il carico sul tuo reparto IT."
}, {
  q: 'Cosa succede se il cliente vuole parlare con un umano?',
  a: "L'operatore umano può subentrare in qualsiasi momento della conversazione. Il passaggio (human handoff) è fluido e l'operatore ha visibilità su tutto lo storico della chat."
}, {
  q: 'I dati sono al sicuro?',
  a: "Assolutamente. L'infrastruttura è 100% GDPR compliant. I dati sono ospitati in server europei e trattati esclusivamente per l'erogazione del servizio."
}, {
  q: 'Funziona anche per spedizioni B2B?',
  a: 'Sì. La piattaforma gestisce sia spedizioni B2C che B2B. Adattiamo il tono di voce, i canali e le logiche di notifica in base al destinatario.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="section-pad border-t border-default bg-elev1" id="faq" data-id="element-63">
      <div className="wrap" data-id="element-64">
        <AnimatedSection data-id="element-65">
          <h2 className="text-display-section mb-12 text-center" data-id="element-66">
            Domande frequenti
          </h2>
        </AnimatedSection>

        <div className="flex flex-col gap-4" data-id="element-67">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <AnimatedSection key={i} delay={0.05 + i * 0.05} data-id="element-68">
                <div className={`border rounded-[var(--r-lg)] overflow-hidden transition-colors duration-300 ${isOpen ? 'border-[var(--accent-500)] bg-elev2' : 'border-default bg-elev1 hover:border-[var(--accent-300)]'}`} data-id="element-69">
                  <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full text-left px-6 py-5 flex items-center justify-between focus:outline-none" data-id="element-70">
                    <span className={`font-[var(--font-display)] text-lg font-medium pr-4 ${isOpen ? 'color-accent' : 'color-ink-primary'}`} data-id="element-71">
                      {faq.q}
                    </span>
                    <ChevronDown className={`w-5 h-5 shrink-0 color-ink-secondary transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-72" />
                  </button>

                  <div className={`grid transition-all duration-300 ease-in-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-73">
                    <div className="overflow-hidden" data-id="element-74">
                      <div className="px-6 pb-6 pt-2" data-id="element-75">
                        <p className="text-body-base color-ink-secondary" data-id="element-76">
                          {faq.a}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </AnimatedSection>;
        })}
        </div>
      </div>
    </section>;
}